var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function Svg06(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    fill: "none",
    width: 64,
    height: 64,
    viewBox: "0 0 64 64",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "master_svg0_511_44482"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 64,
    height: 64,
    rx: 0
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#master_svg0_511_44482)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 64,
    height: 64,
    rx: 0,
    fill: "#FFFFFF",
    fillOpacity: 1
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 33.99998474121094,
    y: 15,
    width: 3,
    height: 34,
    rx: 1,
    fill: "#C00000",
    fillOpacity: 0.30000001192092896
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 16,
    y: 15,
    width: 21,
    height: 34,
    rx: 1,
    fillOpacity: 0,
    strokeOpacity: 1,
    stroke: "#19191A",
    fill: "none",
    strokeWidth: 1.5
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M47,17.25L40,17.25L40,18.75L47,18.75Q47.25,18.75,47.25,19.0000001L47.25,45Q47.25,45.25,46.9999981,45.25L40,45.25L40,46.75L46.9999981,46.75Q47.724874,46.75,48.2374363,46.237438Q48.75,45.724874,48.75,45L48.75,19.0000001Q48.75,18.27512693,48.2374363,17.76256317Q47.724873099999996,17.25,47,17.25Z",
    fillRule: "evenodd",
    fill: "#19191A",
    fillOpacity: 1
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("ellipse", {
    cx: 26.5,
    cy: 21.5,
    rx: 1.5,
    ry: 1.5,
    fill: "#19191A",
    fillOpacity: 1
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("ellipse", {
    cx: 41.75,
    cy: 23.25,
    rx: 1.25,
    ry: 1.25,
    fill: "#19191A",
    fillOpacity: 1
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("ellipse", {
    cx: 41.75,
    cy: 29.25,
    rx: 1.25,
    ry: 1.25,
    fill: "#19191A",
    fillOpacity: 1
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("ellipse", {
    cx: 26.5,
    cy: 29.5,
    rx: 1.5,
    ry: 1.5,
    fill: "#19191A",
    fillOpacity: 1
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M31.5,38.75L21.5,38.75L21.5,37.25L31.5,37.25L31.5,38.75Z",
    fillRule: "evenodd",
    fill: "#19191A",
    fillOpacity: 1
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M44.5,37.75L39.5,37.75L39.5,36.25L44.5,36.25L44.5,37.75Z",
    fillRule: "evenodd",
    fill: "#19191A",
    fillOpacity: 1
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M44.5,41.75L39.5,41.75L39.5,40.25L44.5,40.25L44.5,41.75Z",
    fillRule: "evenodd",
    fill: "#19191A",
    fillOpacity: 1
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M31.5,43.75L21.5,43.75L21.5,42.25L31.5,42.25L31.5,43.75Z",
    fillRule: "evenodd",
    fill: "#19191A",
    fillOpacity: 1
  })))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(Svg06);
export default __webpack_public_path__ + "static/media/06.8b71a3425dfcbbea528527668101d560.svg";
export { ForwardRef as ReactComponent };